
<template>
  <div class="orderInformation">
      <div class="main" v-if="detailsType">
          <div class="top-search">
              <div class="item"><span>订单号：</span><div><el-input v-model="orderNo" placeholder="单行输入"></el-input></div></div>
              <div class="item"><span>业务进度：</span><div><el-select v-model="statusValue" placeholder="请选择">
                <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select></div></div>
              <div class="item"><span>创建时间：</span><div>
                  <el-date-picker
                    v-model="merchantsTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker></div>
              </div>
              <div class="item"><span style="width: 50px;"></span><el-button type="primary" @click="merchantsSearch">搜索</el-button> <el-button type="danger" @click="merchantsReset">重置</el-button></div>
          </div>
          <!-- <div class="middle-button"><el-button type="primary" plain>下载列表</el-button></div> -->
          <div class="bottom-table">
              <el-table
                :data="ordertableData"
                border
                height="670"
                style="width: 100%">
                <el-table-column
                prop="order_id"
                label="订单编号">
                </el-table-column>
                <el-table-column
                prop="order.legalName"
                label="法人姓名">
                </el-table-column>
                <el-table-column
                prop="order.idcard"
                label="法人身份证">
                </el-table-column>
                <el-table-column
                prop="order.price"
                label="订单价格">
                </el-table-column>
                <el-table-column
                prop="created_at"
                label="创建时间">
                </el-table-column>
                <el-table-column
                prop="statusName"
                label="业务进度">
                </el-table-column>
                <el-table-column
                prop="status"
                label="审核备注">
                </el-table-column>
                <el-table-column
                prop="address"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <div style="cursor: pointer;">
                      <el-dropdown>
                          <span class="el-dropdown-link">
                              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item><el-button @click="orderDetails(scope.row)" type="primary" size="mini" plain>查看详情</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status == 1030"><el-button @click="orderClosed(scope.row)" type="danger" size="mini" plain>订单关闭</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="orderStatusSet.indexOf(scope.row.status) === Number('-1')"><el-button @click="newProgress(scope.row)" type="danger" size="mini" plain>{{scope.row.status == 1120 || scope.row.status == 1140 ? '提交审核' : '新建进度'}}</el-button></el-dropdown-item>
                              <el-dropdown-item v-if="scope.row.status != 1170 && scope.row.status != 1040"><el-button @click="orderRedact(scope.row)" type="warning" size="mini" plain>&emsp;编辑&emsp;</el-button></el-dropdown-item>
                          </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                </template>
                </el-table-column>
            </el-table>
          </div>
          <!-- <div class="bottom-pag">
            <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="currentChange">
            </el-pagination>
          </div> -->
          <pagination :total="total" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
      </div>
      <!-- 详情 -->
      <div class="main details" v-if="!detailsType">
        <div class="title">
          <div class="fanhui" @click="detailsType = true"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="qianyue">客户签约</div>
        </div>
        <div class="content">
          <div class="name">基本信息</div>
          <div class="box">
            <span>订单号：{{orderListObj.id}}</span><span>创建时间：{{orderListObj.created_at}}</span><span>订单状态：{{orderListObj.statusName}}</span>
            <span>订单金额（元）：{{orderListObj.price}}</span>
          </div>
          <div class="name">订单详情</div>
          <div class="box2">
            <span>法人姓名：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.legalName" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>法人身份证号码：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.idcard" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>法人联系电话：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.legalMobile" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>法人银行卡号：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.bankNo" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>注册资本：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.capital" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>个体工商户名称：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.name" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>经营范围：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessType" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>经营范围详情：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessScope" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <div class="box_imgs">
              <div class="box-item"><div>身份证正面：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.idcardFront)" :src="orderListObj.idcardFront" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,1,'idcardFront')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.idcardFront" :src="orderListObj.idcardFront">
                  <img v-else src="" alt="">
                </el-upload></div>
              </div>
              <div class="box-item"><div>身份证反面：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.idcardBack)" :src="orderListObj.idcardBack" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,1,'idcardBack')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.idcardBack" :src="orderListObj.idcardBack">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
              <div class="box-item"><div>银行卡照片：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.bankImg)" :src="orderListObj.bankImg" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,1,'bankImg')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.bankImg" :src="orderListObj.bankImg">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="name">个体工商户执照信息</div>
          <div class="box2">
            <span>个体工商户名称：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.name" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>统一社会信用代码：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.creditCode" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>经营场所：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.businessPlace" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>法人：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.legalName" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>法人身份证号码：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.idcard" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>注册日期：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.regDate" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>经营范围：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.businessScope" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <div class="box_imgs">
              <div class="box-item"><div>执照照片：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.businessImg)" :src="orderListObj.businessmen.businessImg" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'businessImg')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.businessImg" :src="orderListObj.businessmen.businessImg">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="name">个体工商户刻章信息</div>
          <div class="box2">
            <div class="box_imgs">
              <div class="box-item"><div>公章：&emsp;</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.gongzhang)" :src="orderListObj.businessmen.gongzhang" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'gongzhang')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.gongzhang" :src="orderListObj.businessmen.gongzhang">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
              <div class="box-item"><div>发票章：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.fapiaozhang)" :src="orderListObj.businessmen.fapiaozhang" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'fapiaozhang')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.fapiaozhang" :src="orderListObj.businessmen.fapiaozhang">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
              <div class="box-item"><div>法人章：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.farenzhang)" :src="orderListObj.businessmen.farenzhang" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'farenzhang')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.farenzhang" :src="orderListObj.businessmen.farenzhang">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
              <div class="box-item"><div>财务章：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.caiwuzhang)" :src="orderListObj.businessmen.caiwuzhang" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'caiwuzhang')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.caiwuzhang" :src="orderListObj.businessmen.caiwuzhang">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
              <div class="box-item"><div>合同章：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.hetongzhang)" :src="orderListObj.businessmen.hetongzhang" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'hetongzhang')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.hetongzhang" :src="orderListObj.businessmen.hetongzhang">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="name">个体工商户开户信息</div>
          <div class="box">
            <span>银行开户：<span v-if="inputType">{{orderListObj.businessmen.isBank}}</span><div v-else style="width: 200px;display: inline-block;"><el-switch v-model="orderListObj.businessmen.isBank" active-color="#13ce66" inactive-color="#ff4949"></el-switch></div></span>
            <span>账户名称：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.bankName" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>账号：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.bankNo" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span><br/>
            <span>开户行：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.bank" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <div class="box_imgs">
              <div class="box-item"><div>账户图片：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.bankImg)" :src="orderListObj.businessmen.bankImg" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'bankImg')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.bankImg" :src="orderListObj.businessmen.bankImg">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="name">个体工商户税务报道</div>
          <div class="box">
            <span>税务登记日：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.taxRegDay" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <span>税务机构名称：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.taxOrg" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <div class="box_imgs">
              <div class="box-item"><div>CA：&emsp;</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.caImg)" :src="orderListObj.businessmen.caImg" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'caImg')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.caImg" :src="orderListObj.businessmen.caImg">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="name">订单交付</div>
          <div class="box">
            <span>审核状态：{{orderListObj.deliver.auditResult}}</span><br/>
            <span>审核内容：{{orderListObj.deliver.auditRemark}}</span><br/>
            <span>交付内容：{{orderListObj.deliver.content}}</span><br/>
            <span>收件人：{{orderListObj.deliver.addressee}}</span><br/>
            <span>联系电话：{{orderListObj.deliver.mobile}}</span><br/>
            <span>邮寄地址：{{orderListObj.deliver.addr}}</span><br/>
          </div>
          <div class="name">邮寄信息</div>
          <div class="box">
            <span>快递单号：<div style="width: 200px;display: inline-block;"><el-input v-model="orderListObj.businessmen.courierNo" size="mini" :disabled="inputType" placeholder="单行输入"></el-input></div></span>
            <div class="box_imgs">
              <div class="box-item"><div>交接单：</div><div class="box_img">
                <img v-if="inputType" @click="detailsImage(orderListObj.businessmen.courierImg)" :src="orderListObj.businessmen.courierImg" alt="">
                <el-upload
                  v-else
                  style="width:100%;height:100%"
                  :action="data.action"
                  :data="data.d"
                  :show-file-list="false"
                  :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,2,'courierImg')"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="orderListObj.businessmen.courierImg" :src="orderListObj.businessmen.courierImg">
                  <img v-else src="" alt="">
                </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div><el-button type="primary" @click="modification">修改</el-button><el-button @click="cancel">取消</el-button></div>
        </div>
      </div>
      <el-dialog
        title="新建订单进度"
        :visible.sync="dialogOrder"
        width="575px"
        :before-close="handleClose">
        <div style="width: 390px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="orderForm" label-width="100px">
            <el-form-item label="订单进度：">
              <div style="width:233px">
              <el-input v-model="orderForm.rateOfProgress" disabled></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="orderConfirm">确定</el-button>
              <el-button @click="dialogOrder = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 新建订单进度 执照 -->
      <el-dialog
        title="新建订单进度"
        :visible.sync="dialogOrder0"
        width="673px"
        :before-close="handleClose">
        <div style="width: 390px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="orderForm" label-width="140px">
            <el-form-item label="订单进度：">
              <div style="width:233px"><el-input v-model="orderForm.rateOfProgress" disabled></el-input></div>
            </el-form-item>
            <el-form-item label="个体工商户名称：">
              <div style="width:233px"><el-input v-model="orderForm.name" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="统一社会信用代码：">
              <div style="width:233px"><el-input v-model="orderForm.creditCode" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="经营场所：">
              <div style="width:233px"><el-input v-model="orderForm.businessPlace" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="经营范围：">
              <div style="width:233px"><el-input type="textarea" resize="none" :rows="4" placeholder="多行输入" v-model="orderForm.businessScope"></el-input></div>
            </el-form-item>
            <el-form-item label="注册日期：">
              <div style="width:233px"><el-input v-model="orderForm.regDate" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="执照照片：">
              <el-upload
                class="avatar-uploader"
                :action="data.action"
                :data="data.d"
                :show-file-list="false"
                :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'businessImg')"
                :before-upload="beforeAvatarUpload">
                <img v-if="orderForm.businessImg" :src="orderForm.businessImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="orderConfirm">确定</el-button>
              <el-button @click="dialogOrder0 = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 新建订单进度 刻章 -->
      <el-dialog
        title="新建订单进度"
        :visible.sync="dialogOrder1"
        width="725px"
        :before-close="handleClose">
        <div style="width: 600px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="orderForm" label-width="90px">
            <el-form-item label="订单进度：">
              <div style="width:233px">
              <el-input v-model="orderForm.rateOfProgress" disabled></el-input>
              </div>
            </el-form-item>
            <div style="overflow: hidden;">
              <el-form-item label="公章：" style="float: left;margin-right: 20px">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'gongzhang')"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderForm.gongzhang" :src="orderForm.gongzhang" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
              <el-form-item label="财务章：" style="float: left;margin-right: 20px">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'caiwuzhang')"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderForm.caiwuzhang" :src="orderForm.caiwuzhang" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
              <el-form-item label="发票章：" style="float: left;margin-right: 20px">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'fapiaozhang')"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderForm.fapiaozhang" :src="orderForm.fapiaozhang" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
              <el-form-item label="合同章：" style="float: left;margin-right: 20px">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'hetongzhang')"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderForm.hetongzhang" :src="orderForm.hetongzhang" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
              <el-form-item label="法人章：" style="float: left;margin-right: 20px">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'farenzhang')"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderForm.farenzhang" :src="orderForm.farenzhang" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
            </div>
            <div style="width: 100%;text-align: center;">
              <el-button type="primary" @click="orderConfirm">确定</el-button>
              <el-button @click="dialogOrder1 = false">取消</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>
      <!-- 新建订单进度 银行 -->
      <el-dialog
        title="新建订单进度"
        :visible.sync="dialogOrder2"
        width="575px"
        :before-close="handleClose">
        <div style="width: 390px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="orderForm" label-width="100px">
            <el-form-item label="订单进度：">
              <div style="width:233px">
              <el-input v-model="orderForm.rateOfProgress" disabled></el-input>
              </div>
            </el-form-item>
            <el-form-item label="银行开户：">
              <el-switch v-model="orderForm.isBank"></el-switch>
            </el-form-item>
            <el-form-item label="账户名称：">
              <div style="width:233px">
              <el-input v-model="orderForm.bankName"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="账号：">
              <div style="width:233px">
              <el-input v-model="orderForm.bankNo"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="开户行：">
              <div style="width:233px">
              <el-input v-model="orderForm.bank"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="账户开户：">
              <el-upload
                class="avatar-uploader"
                :action="data.action"
                :data="data.d"
                :show-file-list="false"
                :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList, 0,'bankImg')"
                :before-upload="beforeAvatarUpload">
                <img v-if="orderForm.bankImg" :src="orderForm.bankImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="orderConfirm">确定</el-button>
              <el-button @click="dialogOrder2 = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 新建订单进度 税务 -->
      <el-dialog
        title="新建订单进度"
        :visible.sync="dialogOrder3"
        width="528px"
        :before-close="handleClose">
        <div style="width: 390px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="orderForm" label-width="110px">
            <el-form-item label="订单进度：">
              <div style="width:233px">
              <el-input v-model="orderForm.rateOfProgress" disabled></el-input>
              </div>
            </el-form-item>
            <el-form-item label="CA照片：">
              <el-upload
                class="avatar-uploader"
                :action="data.action"
                :data="data.d"
                :show-file-list="false"
                :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'caImg')"
                :before-upload="beforeAvatarUpload">
                <img v-if="orderForm.caImg" :src="orderForm.caImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="税务登记日：">
              <div style="width:233px">
              <el-input v-model="orderForm.taxRegDay"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="税务机构名称：">
              <div style="width:233px">
              <el-input v-model="orderForm.taxOrg"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="orderConfirm">确定</el-button>
              <el-button @click="dialogOrder3 = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 新建订单进度 邮寄 -->
      <el-dialog
        title="新建订单进度"
        :visible.sync="dialogOrder4"
        width="598px"
        :before-close="handleClose">
        <div style="width: 440px; margin: 0 auto; text-align: left;">
          <el-form ref="orderForm" :model="orderForm" label-width="140px">
            <el-form-item label="订单进度：">
              <div style="width:233px"><el-input v-model="orderForm.rateOfProgress" disabled></el-input></div>
            </el-form-item>
            <el-form-item label="快递单号：">
              <div style="width:233px"><el-input v-model="orderForm.courierNo" placeholder="单行输入"></el-input></div>
            </el-form-item>
            <el-form-item label="交接单：">
                  <el-upload
                    class="avatar-uploader"
                    :action="data.action"
                    :data="data.d"
                    :show-file-list="false"
                    :on-success="(response, file, fileList)=>handleAvatarSuccess(response, file, fileList,0,'courierImg')"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="orderForm.courierImg" :src="orderForm.courierImg" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只支持.jpg格式</div>
                  </el-upload>
              </el-form-item>
            <div style="width: 100%;text-align: center;">
              <el-button type="primary" @click="orderConfirm">确定</el-button>
              <el-button @click="dialogOrder4 = false">取消</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>
      <!-- 图片查看 -->
      <el-dialog
        title="图片查看"
        :visible.sync="dialogImg"
        width="50%"
        :before-close="handleClose">
        <div>
          <img :src="imageDetails" alt="">
        </div>
      </el-dialog>
  </div>
</template>

<script>
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
import pagination from '@/components/pagination'
export default {
  data() {
    return {
      imageDetails: '',
      dialogImg: false,
      pageSzie: 10,
      total: null,
      dialogOrder: false,
      dialogOrder0: false,
      dialogOrder1: false,
      dialogOrder2: false,
      dialogOrder3: false,
      dialogOrder4: false,
      detailsType: true,
      inputType: true,
      orderListObj: {},
      ordertableData: [],
      orderForm: {
        id: "1",                         // 订单id
        status: "10",                         // 订单状态
        rateOfProgress: '',
        // 执照
        name: '',
        creditCode: '',
        businessPlace: '',
        businessScope: '',
        regDate: '',
        businessImg: '',
        // 刻章办理
        gongzhang: '',            // 公章
        caiwuzhang: '',          // 财务章
        fapiaozhang: '',        // 发票章
        hetongzhang: '',        // 合同章
        farenzhang: '',
        // 银行
        isBank: 1,
        bankName: '',
        bankNo: '',
        bank: '',
        bankImg: '',
        // 税务
        caImg: '',
        taxRegDay: '',
        taxOrg: '',
        // 邮寄
        courierNo: '',
        courierImg: ''
      },
      orderOptions: [],
      orderValue: '',
      orderNo:'',
      statusOptions: [
        {value:"1030", label: "待处理"},
        {value:"1040", label: "交付商关闭"},
        {value:"1050", label: "执照办理中"},
        {value:"1060", label: "已出执照"},
        {value:"1070", label: "刻章办理中"},
        {value:"1080", label: "已刻章"},
        {value:"1090", label: "银行开户中"},
        {value:"1100", label: "银行卡已开户"},
        {value:"1110", label: "税务报道中"},
        {value:"1120", label: "已税务报道"},
        {value:"1130", label: "提交审核"},
        {value:"1140", label: "审核失败"},
        {value:"1150", label: "审核通过"},
        {value:"1160", label: "已邮寄"}
      ],
      statusValue: '',
      merchantsTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      data: {
        d: {},
        action: ''
      },
      orderDetailsObj: {
        // 订单对象
        order: {
            "id": "13180527789003380",                          // 订单id\订单号
            "legalName": "杨庆菊",                               // 法人姓名
            "idcard": "123身份证",                               // 身份证号码
            "legalMobile": "杨庆菊手机号",                        // 法人手机号
            "bankNo": "2222",                                   // 银行卡号
            "capital": "到底是多少",                              // 注册资本
            "names": "山驴比1,山驴比2,山驴比3",                    // 2～3个个体工商户名称
            "businessType": "太难了",                            // 经营范围
            "businessScope": "太狠了",                           // 经营范围详情
            "idcardFront": "在正面",                             // 身份证正面图
            "idcardBack": "反面",                                // 身份证反面图
        },
        // 个体工商户信息
        businessmen: {
            "id": "12795594625000138",                          // 个体户id
            // 个体工商户执照信息
            "name": "杨庆菊有限公司",                             // 个体户名称
            "creditCode": "xxxxxx333333333",                    // 统一社会信用代码
            "businessPlace": "来广营地铁站",                      // 经营场所
            "legalName": "杨庆菊",                               // 法人姓名
            "legalMobile": "杨庆菊手机号",                        // 法人手机号
            "legalIdcard": "2222222222",                        // 法人身份证号
            "regDate": "2019-01-22",                            // 注册日期
            "businessScope": "1,2，3,4,5，",                     // 经营范围
            "businessImg": "http:1.png",                        // 执照照片
            // 个体工商户刻章信息
            "gongzhang": "http://gongzhang.png",                // 公章
            "caiwuzhang": "http://caiwuzhang.png",              // 财务章
            "fapiaozhang": "http://fapiaozhang.png",            // 发票章
            "hetongzhang": "http://hetongzhang.png",            // 合同章
            "farenzhang": "http://farenzhang.png",              // 法人章
            // 个体户开户信息   
            "isBank": 1,                                        // 是否开户 0否 1是
            "bankName": "https://bankName",                     // 账户名称
            "bankNo": "https://bankNo",                         // 帐号
            "bank": "https://bank",                             // 开户行
            "bankImg": "https://bankImg",                       // 账户图片
            // 税务报道信息
            "caImg": "12313212",                                // CA照片
            "taxRegDay": "2019-01-01",                          // 税务登记日
            "taxOrg": "12333",                                  // 税务机构名称
            // 邮寄信息
            "courierNo": "111111111",                           // 快递单号
            "courierImg": "快递交接图片",                         // 快递交接图片
        }
      },
      orderStatusSet:['1010','1040','1130','1140','1160']
    }
  },
  mounted() {
    this.orderOptions = JSON.parse(localStorage.getItem('nameList')) || []
    this.orderToListPost()
    this.getUploadConfig()
  },
  methods: {
    detailsImage(src) {
      if (src) {
        this.imageDetails = src
        this.dialogImg = true
      }
    },
    // 确定
    orderConfirm() {
      post(api.deliverHandle, this.orderForm)
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success'
          });
          Object.keys(this.orderForm).forEach(key => this.orderForm[key] = '');
          this.orderToListPost()
          this.dialogOrder = false
          this.dialogOrder0 = false
          this.dialogOrder1 = false
          this.dialogOrder2 = false
          this.dialogOrder3 = false
          this.dialogOrder4 = false
        }else {
          this.$message({
            showClose: true,
            message: d.msg,
            type: 'warning'
          });
          console.log(d.msg)
        }
      }, (err) => {
          //error callback
      })
    },
    getUploadConfig() {
        var that = this;
        post(api.getOssConfig)
        .then((d) => {
          console.log(d,'阿里接口')
          that.data.d["key"] = "zc_wxapplet_" + new Date().getTime() + ".jpg";
          that.data.d["Bucket"] = d.Bucket;
          that.data.d["OSSAccessKeyId"] = d.OSSAccessKeyId;
          that.data.d["signature"] = d.Signature;
          that.data.d["policy"] = d.policy;
          that.data.d["success_action_status"] = d.success_action_status;
          that.data.action = d.url;
        }, (err) => {
            //error callback
        })
    },
    // 重置
    merchantsReset() {
      this.orderValue = ''
      this.orderNo = ''
      this.statusValue = ''
      this.merchantsTime = [
        '',''
      ]
      this.orderToListPost()
    },
    // 搜索
    merchantsSearch() {
      if (this.merchantsTime.length == 0 ) {
        console.log('空的')
        this.merchantsTime = [
          '',''
        ]
      }
      console.log(this.merchantsTime)
      this.orderToListPost()
    },
    // 列表
    orderToListPost(size) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      post(api.handlePage, {
        currentPage: size || 1,
        pageSize: this.pageSzie,
        merchantId: this.orderValue,
        orderNo: this.orderNo,
        channelOrderNo: '',
        createdBegin: this.merchantsTime[0],
        createdEnd: this.merchantsTime[1],
        status: this.statusValue
      })
      .then((d) => {
        console.log(d)
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.total = d.data.count
          loading.close();
          // for (let i = 0; i < d.data.rows.length; i++) {
          //   d.data.rows[i].nameArr = d.data.rows[i].names.split(',')
          // }
          this.ordertableData = d.data.rows
        }else {
          this.ordertableData = []
        }
      }, (err) => {
          //error callback
      })
    },
    handleSizeChange(val) {
      this.pageSzie = val
      console.log(`每页 ${val} 条aaaaa`);
      this.orderToListPost()
    },
    handleCurrentChange(size) {
      console.log(size)
      this.orderToListPost(size)
    },
    // 编辑
    orderRedact(row) {
      this.inputType = false
      post(api.deliverInfo, {
        id: row.order_id
      })
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.orderListObj = d.data
          this.detailsType = false
        }else {
          console.log(d.msg)
        }
      }, (err) => {
        console.log(err,'出错啦')
          //error callback
      })
    },
    orderDetails(row) {
      console.log(row)
      this.inputType = true
      post(api.deliverInfo, {
        id: row.order_id
      })
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'!!!!!!!!!!!!')
          this.orderListObj = d.data
          this.detailsType = false
        }else {
          console.log(d.msg)
        }
      }, (err) => {
        console.log(err,'出错啦')
          //error callback
      })
    },
    newProgress(row) {
      console.log(row.status)
      this.orderForm.id = row.id
      this.orderForm.status = row.nextStatus
      this.orderForm.rateOfProgress = row.nextStatusName
      if (row.status == 1050) {
        this.dialogOrder0 = true
      }else if (row.status == 1070) {
        this.dialogOrder1 = true
      }else if (row.status == 1090) {
        this.dialogOrder2 = true
      }else if (row.status == 1110) {
        this.dialogOrder3 = true
      }else if (row.status == 1150) {
        this.dialogOrder4 = true
      }else {
        this.dialogOrder = true
      }
    },
    handleClose(done) {
      done();
    },
    handleAvatarSuccess(res, file, files, key,val) {
      // console.log(res, file, files, key)
      var result = res.substring(res.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), res.indexOf('</Location>'));
      if (key == 0) {
        this.orderForm[val] = result
      //   this.orderForm.gongzhang = result
      // }else if (key == 1) {
      //   this.orderForm.caiwuzhang = result
      // }else if (key == 2) {
      //   this.orderForm.fapiaozhang =result
      // }else if (key == 3) {
      //   this.orderForm.hetongzhang = result
      // }else if (key == 4) {
      //   this.orderForm.farenzhang = result
      // }else if (key == 'business') {
      //   this.orderForm.businessImg = result
      // }else if (key == 'bank') {
      //   this.orderForm.bankImg = result
      // }else if (key == 'ca') {
      //   this.orderForm.caImg = result
      // }else if (key == 'idcardFront') {
      //   this.orderDetailsObj.order.idcardFront = result
      }else if (key == 1) {
        this.orderListObj[val] = result
        // this.orderForm.courierImg = result
      }else {
        this.orderListObj.businessmen[val] = result
      }
      console.log(result,'上传成功')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      return isJPG;
    },
    orderClosed(row) {
      this.$confirm('此操作将关闭该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(api.deliverClose,{
          "id": row.id
        })
        .then((d) => {
            console.log(d,'关闭')
            if (d.status === 0) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.orderToListPost()
            }
        }, (err) => {
            //error callback
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })        
      })
      
    },
    modification() {
      post(api.deliverEdit, {
        order:{
          "id": this.orderListObj.id,                          // 订单id\订单号
          "legalName": this.orderListObj.legalName,            // 法人姓名
          "idcard": this.orderListObj.idcard,                               // 身份证号码
          "legalMobile": this.orderListObj.legalMobile,                        // 法人手机号
          "bankNo": this.orderListObj.bankNo,                                   // 银行卡号
          "capital": this.orderListObj.capital,                              // 注册资本
          "names": this.orderListObj.names,                    // 2～3个个体工商户名称
          "businessType": this.orderListObj.businessType,                            // 经营范围
          "businessScope": this.orderListObj.businessScope,                           // 经营范围详情
          "idcardFront": this.orderListObj.idcardFront,                             // 身份证正面图
          "idcardBack": this.orderListObj.idcardBack,                                // 身份证反面图
        },
        businessmen: this.orderListObj.businessmen
      })
      .then((d) => {
        if (d.status === 0) {
          console.log(d,'提交修改成功')
        }else {
          console.log(d.msg)
        }
      }, (err) => {
        console.log(err,'出错啦')
          //error callback
      })
      this.detailsType = true
    },
    cancel() {
      this.detailsType = true
    }
  },
  created() {

  },
  components: {
    pagination: pagination
  }
}
</script>

<style lang="less" scoped>
.orderInformation {
    width: 100%;
    padding: 22px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    .main {
        width: 100%;
        height: 100%;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        .top-search {
            width: 100%;
            overflow: hidden;
            .item {
                height: 46px;
                line-height: 46px;
                float: left;
                margin-bottom: 10px;
                span {
                    display: inline-block;
                    width: 81px;
                    font-size:14px;
                    font-family:PingFangSC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    text-align: right;
                    margin-right: 10px;
                }
                div {
                    display: inline-block;
                    width:233px;
                    height:46px;
                }
            }
        }
        .middle-button {
            width: 100%;
            text-align: left;
            padding-top: 10px;
        }
        .bottom-table {
            width: 100%;
            margin-top: 20px;
        }
        .bottom-pag {
            width: 100%;
            margin-top: 20px;
        }
    }
    .details {
      .title {
        width: 100%;
        height: 52px;
        line-height: 52px;
        .fanhui {
          float: left;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:400;
          color:rgba(102,102,102,1);
          position: relative;
          cursor: pointer;
        }
        .fanhui:after {
          content: '';
          position: absolute;
          top: 20px;
          right: -16px;
          width: 1px;
          height: 13px;
          background-color: #979797;
        }
        .qianyue {
          float: left;
          margin-left: 24px;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:500;
          color:rgba(51,51,51,1);
        }
      }
      .content {
        width: 100%;
        .name {
          width: 100%;
          font-size:14px;
          font-family:PingFangSC;
          font-weight:600;
          color:rgba(51,51,51,1);
          text-align: left;
          padding-left: 10px;
          box-sizing: border-box;
        }
        .box {
          margin-top: 10px;
          width: 100%;
          padding: 30px 65px;
          box-sizing: border-box;
          // background:rgba(250,250,250,1);
          border-radius:6px;
          text-align: left;
          span {
            min-width: 33.33%;
            display: inline-block;
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(51,51,51,1);
            // margin: 0px 55px;
            line-height: 36px;
          }
          .box_imgs {
            width: 100%;
            overflow: hidden;
            padding: 8px 0px;
            box-sizing: border-box;
            .box-item {
              min-width: 200px;
              margin-right: 10px;
              font-size: 14px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #333333;
              div {
                margin-right: 10px;
              }
              .box_img {
                width: 200px;
                height: 120px;
                display: inline-block;
                background-color: #eee;
                margin-top: 8px;
                margin-right: 50px;
                .el-upload {
                  width: 100% !important;
                  height: 100% !important;
                  img {
                    display: inline-block;
                    width: 200px;
                    height: 120px;
                  }
                }
                img {
                  cursor: pointer;
                  display: block;
                  height: 100%;
                  margin: 0 auto;
                }
              }
            }
            div {
              float: left;
            }
            
          } 
        }
        .box2 {
          margin-top: 10px;
          width: 100%;
          padding: 30px 65px;
          box-sizing: border-box;
          border-radius:6px;
          text-align: left;
          overflow: hidden;
          span {
            min-width: 33.33%;
            float: left;
            font-size:14px;
            font-family:PingFangSC;
            font-weight:400;
            color:rgba(51,51,51,1);
            // margin: 0px 55px;
            line-height: 36px;
          }
          .box_imgs {
            width: 100%;
            overflow: hidden;
            padding: 8px 0px;
            box-sizing: border-box;
            .box-item {
              min-width: 200px;
              margin-right: 10px;
              font-size: 14px;
              font-family: PingFangSC;
              font-weight: 400;
              color: #333333;
              div {
                margin-right: 10px;
              }
              .box_img {
                width: 200px;
                height: 120px;
                display: inline-block;
                background-color: #eee;
                margin-top: 8px;
                margin-right: 50px;
                .el-upload {
                  width: 100% !important;
                  height: 100% !important;
                  img {
                    display: inline-block;
                    width: 200px;
                    height: 120px;
                  }
                }
                img {
                  cursor: pointer;
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                }
              }
            }
            div {
              float: left;
            }
            
          } 
        }
        .box1 {
          margin-top: 10px;
          width: 100%;
          padding: 30px 10px;
          box-sizing: border-box;;
          border-radius:6px;
          text-align: left;
          overflow: hidden;
          .item {
            float: left;
            height:93px;
            margin-right: 100px;
            margin-bottom: 20px;
            div {
              float: left;
              min-width: 55px;
              height: 93px;
            }
            .picture {
              width:167px;
              height:93px;
              background:rgba(246,246,246,1);
              border-radius:8px;
              border:1px solid rgba(198,198,198,1);
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          
        }
      }
    }
}
</style>

<style>
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/trading/order/orderInformation.vue